import React, { useState, useEffect, useMemo } from 'react';
import ProcessMiningDashboard from './components/ProcessMiningDashboard';
import { EventLog, ActivityType, PainType, LifecycleTransition } from './types/processMining';
import { PacienteProtocolo } from './types';
import { gerarDadosMock } from './utils/dataProcessing';

function App() {
  const [carregando, setCarregando] = useState(true);
  const [eventLogs, setEventLogs] = useState<EventLog[]>([]);

  // Função para gerar EventLogs simulados
  const gerarEventLogs = (): EventLog[] => {
    const logs: EventLog[] = [];
    const caseIds = ['CASE_001', 'CASE_002', 'CASE_003', 'CASE_004', 'CASE_005', 'CASE_006'];
    const resources = ['Dr. Silva', 'Enfermeira Ana', 'Dr. Costa', 'Enfermeira Maria', 'Fisioterapeuta João'];
    const departments = ['UTI', 'Enfermaria', 'Cirúrgico', 'Emergência'];
    
    const activities: ActivityType[] = [
      ActivityType.pain_assessment_initial,
      ActivityType.medication_administration,
      ActivityType.pain_reassessment,
      ActivityType.response_evaluation,
      ActivityType.protocol_modification,
      ActivityType.discharge_planning
    ];

    // Gerar eventos para cada caso
    caseIds.forEach((caseId, index) => {
      const baseTime = new Date(Date.now() - (index * 24 * 60 * 60 * 1000)); // Dias anteriores
      
      activities.forEach((activity, actIndex) => {
        const timestamp = new Date(baseTime.getTime() + (actIndex * 60 * 60 * 1000)); // Horas de intervalo
        
        logs.push({
          case_id: caseId,
          activity: activity,
          timestamp: timestamp,
          resource: resources[Math.floor(Math.random() * resources.length)],
          lifecycle: LifecycleTransition.complete,
          event_id: `EVENT_${caseId}_${actIndex}`,
          organization: 'Hospital Santa Maria',
          process_instance: `PROC_${caseId}`,
          attributes: {
            patient_id: `PAT_${index + 1}`,
            patient_age: 30 + Math.floor(Math.random() * 50),
            gender: Math.random() > 0.5 ? 'M' : 'F',
            admission_type: Math.random() > 0.5 ? 'emergency' : 'elective',
            admission_datetime: new Date(baseTime.getTime() - (2 * 60 * 60 * 1000)),
            pain_level_before: 4 + Math.floor(Math.random() * 6),
            pain_level_after: 1 + Math.floor(Math.random() * 4),
            pain_type: Object.values(PainType)[Math.floor(Math.random() * Object.values(PainType).length)],
            comorbidities: ['Diabetes', 'Hipertensão'].slice(0, Math.floor(Math.random() * 2) + 1),
            department: departments[Math.floor(Math.random() * departments.length)],
            unit: 'Unidade A',
            shift: Math.random() > 0.5 ? 'morning' : 'afternoon',
            bed_occupancy_rate: 0.6 + Math.random() * 0.3,
            staff_workload_index: 0.5 + Math.random() * 0.4,
            protocol_compliance_score: 0.7 + Math.random() * 0.3,
            day_of_week: timestamp.getDay(),
            hour_of_day: timestamp.getHours(),
            documentation_completeness: 0.8 + Math.random() * 0.2,
            guideline_adherence_score: 0.75 + Math.random() * 0.25,
            response_time_sla_met: Math.random() > 0.3
          }
        });
      });
    });

    return logs.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
  };

  // Carregar dados simulados na inicialização
  useEffect(() => {
    const timer = setTimeout(() => {
      const logs = gerarEventLogs();
      setEventLogs(logs);
      setCarregando(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (carregando) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Inicializando Process Mining</h2>
          <p className="text-gray-600">Carregando sistema de análise de processos...</p>
        </div>
      </div>
    );
  }

  return (
    <ProcessMiningDashboard 
      eventLogs={eventLogs}
      onAlgorithmChange={(algorithm) => {
        console.log('Algoritmo selecionado:', algorithm);
      }}
      onFilterChange={(filters) => {
        console.log('Filtros aplicados:', filters);
      }}
    />
  );
}

export default App;
